<script setup>
import {Link} from '@inertiajs/vue3';
import ErrorPageLayout from "@/Layouts/ErrorPageLayout.vue";
</script>

<template>
	<ErrorPageLayout>
		<div class="h-full flex flex-col items-center justify-center px-12">
			<div class="h-full flex flex-col justify-center">
				<p class="text-base/8 font-semibold text-primary-600">OH NO!</p>
				<h1 class="text-4xl font-bold text-dark-100">Page not found</h1>
				<p class="text-lg text-dark-300 py-6">Sorry, we couldn’t find the page you’re looking for.</p>
				<div class="mt-8 flex justify-start">
					<Link :href="route('homepage')"
					      class="inline-flex justify-center text-xs items-center px-4 py-2 bg-primary-600 border border-transparent rounded-md font-semibold text-white uppercase tracking-widest hover:bg-primary-700 focus:bg-primary-700 active:bg-primary-900 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 transition ease-in-out duration-150"
					>Go to Homepage</Link>
				</div>
			</div>

		</div>
	</ErrorPageLayout>
</template>

<style scoped></style>
